module.exports = __webpack_public_path__ + "img/ding.5004cfcd.jpg";